import { usePreferencesStore } from '../../stores/preferencesStore';

const MODES = [
  {
    value: 'toggle',
    label: 'Open mic',
    title: 'Click Record to open the mic; it stays on until you click Stop — for long dictations',
  },
  {
    value: 'push_to_talk',
    label: 'Push-to-talk',
    title: 'Hold the button while dictating; release to transcribe',
  },
  {
    value: 'pause_resume',
    label: 'Pause/Resume',
    title: 'Click Record, then Pause/Resume within one continuous dictation; click Finish to transcribe and submit',
  },
] as const;

/**
 * Compact mic-mode dropdown. Was a three-way radio group, which wrapped the
 * dictation header onto a second line at the panel's fixed 20rem width.
 */
export default function ModeSelector() {
  const { preferences, updatePreferences } = usePreferencesStore();

  if (!preferences) return null;

  const current = MODES.find((m) => m.value === preferences.voice_input_mode);

  return (
    <label className="flex items-center gap-1.5 text-sm">
      <span className="text-gray-500 dark:text-gray-400">Mode</span>
      <select
        value={preferences.voice_input_mode}
        onChange={(e) => updatePreferences({ voice_input_mode: e.target.value as typeof MODES[number]['value'] })}
        title={current?.title}
        className="text-sm border border-gray-300 dark:border-surface-700 rounded-md px-2 py-1 bg-white dark:bg-surface-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-primary-500"
      >
        {MODES.map((m) => (
          <option key={m.value} value={m.value} title={m.title}>
            {m.label}
          </option>
        ))}
      </select>
    </label>
  );
}
